import { systemProp2qpti4y1f5b4b as systemProp } from '../internal/SystemProps.common.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  captureStack1fzi4aczwc4hg as captureStack,
  toString1pkumu07cwy4m as toString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  BufferOverflow_SUSPEND_getInstance1ucmryz5dsuc2 as BufferOverflow_SUSPEND_getInstance,
  BufferOverflow_DROP_OLDEST_getInstance2xuwx7fze5aij as BufferOverflow_DROP_OLDEST_getInstance,
} from './BufferOverflow.mjs';
import { ConflatedBufferedChannel16nes42ao4b78 as ConflatedBufferedChannel } from './ConflatedBufferedChannel.mjs';
import { BufferedChannel3lgkhzot5gmk6 as BufferedChannel } from './BufferedChannel.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var FactoryClass;
function Factory() {
  if (FactoryClass === VOID) {
    class $ {
      constructor() {
        Factory_instance = this;
        this.UNLIMITED_1 = 2147483647;
        this.RENDEZVOUS_1 = 0;
        this.CONFLATED_1 = -1;
        this.BUFFERED_1 = -2;
        this.OPTIONAL_CHANNEL_1 = -3;
        this.DEFAULT_BUFFER_PROPERTY_NAME_1 = 'kotlinx.coroutines.channels.defaultBuffer';
        this.CHANNEL_DEFAULT_CAPACITY_1 = systemProp('kotlinx.coroutines.channels.defaultBuffer', 64, 1, 2147483646);
      }
    }
    initMetadataForObject($, 'Factory');
    FactoryClass = $;
  }
  return FactoryClass;
}
var Factory_instance;
function Factory_getInstance() {
  if (Factory_instance === VOID)
    new (Factory())();
  return Factory_instance;
}
function cancel$default(cause, $super) {
  cause = cause === VOID ? null : cause;
  var tmp;
  if ($super === VOID) {
    this.cancel_hkmm2i_k$(cause);
    tmp = Unit_instance;
  } else {
    tmp = $super.cancel_hkmm2i_k$.call(this, cause);
  }
  return tmp;
}
var ReceiveChannelClass;
function ReceiveChannel() {
  if (ReceiveChannelClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ReceiveChannel', VOID, VOID, VOID, [0]);
    ReceiveChannelClass = $;
  }
  return ReceiveChannelClass;
}
function close$default(cause, $super) {
  cause = cause === VOID ? null : cause;
  return $super === VOID ? this.close_ukldxa_k$(cause) : $super.close_ukldxa_k$.call(this, cause);
}
var SendChannelClass;
function SendChannel() {
  if (SendChannelClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'SendChannel', VOID, VOID, VOID, [1]);
    SendChannelClass = $;
  }
  return SendChannelClass;
}
function _ChannelResult___init__impl__siwsuf(holder) {
  return holder;
}
function _ChannelResult___get_holder__impl__pm9gzw($this) {
  return $this;
}
function _ChannelResult___get_isSuccess__impl__odq1z9($this) {
  var tmp = _ChannelResult___get_holder__impl__pm9gzw($this);
  return !(tmp instanceof Failed());
}
function _ChannelResult___get_isClosed__impl__mg7kuu($this) {
  var tmp = _ChannelResult___get_holder__impl__pm9gzw($this);
  return tmp instanceof Closed();
}
function ChannelResult__getOrNull_impl_f5e07h($this) {
  var tmp;
  var tmp_0 = _ChannelResult___get_holder__impl__pm9gzw($this);
  if (!(tmp_0 instanceof Failed())) {
    tmp = _ChannelResult___get_holder__impl__pm9gzw($this);
  } else {
    tmp = null;
  }
  return tmp;
}
function ChannelResult__exceptionOrNull_impl_16ei30($this) {
  var tmp = _ChannelResult___get_holder__impl__pm9gzw($this);
  var tmp0_safe_receiver = tmp instanceof Closed() ? tmp : null;
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.cause_1;
}
var FailedClass;
function Failed() {
  if (FailedClass === VOID) {
    class $ {
      toString() {
        return 'Failed';
      }
    }
    initMetadataForClass($, 'Failed', Failed);
    FailedClass = $;
  }
  return FailedClass;
}
var ClosedClass;
function Closed() {
  if (ClosedClass === VOID) {
    class $ extends Failed() {
      constructor(cause) {
        super();
        this.cause_1 = cause;
      }
      equals(other) {
        var tmp;
        if (other instanceof Closed()) {
          tmp = equals(this.cause_1, other.cause_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver = this.cause_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
      }
      toString() {
        return 'Closed(' + toString_0(this.cause_1) + ')';
      }
    }
    initMetadataForClass($, 'Closed');
    ClosedClass = $;
  }
  return ClosedClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.failed_1 = new (Failed())();
      }
      success_tizbw6_k$(value) {
        return _ChannelResult___init__impl__siwsuf(value);
      }
      failure_q0nifh_k$() {
        return _ChannelResult___init__impl__siwsuf(this.failed_1);
      }
      closed_xuwu5z_k$(cause) {
        return _ChannelResult___init__impl__siwsuf(new (Closed())(cause));
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
function ChannelResult__toString_impl_rrcqu7($this) {
  var tmp;
  if (_ChannelResult___get_holder__impl__pm9gzw($this) instanceof Closed()) {
    tmp = _ChannelResult___get_holder__impl__pm9gzw($this).toString();
  } else {
    tmp = 'Value(' + toString_0(_ChannelResult___get_holder__impl__pm9gzw($this)) + ')';
  }
  return tmp;
}
function ChannelResult__hashCode_impl_lilec2($this) {
  return $this == null ? 0 : hashCode($this);
}
function ChannelResult__equals_impl_f471ri($this, other) {
  if (!(other instanceof ChannelResult()))
    return false;
  var tmp0_other_with_cast = other.holder_1;
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var ChannelResultClass;
function ChannelResult() {
  if (ChannelResultClass === VOID) {
    class $ {
      constructor(holder) {
        Companion_getInstance();
        this.holder_1 = holder;
      }
      toString() {
        return ChannelResult__toString_impl_rrcqu7(this.holder_1);
      }
      hashCode() {
        return ChannelResult__hashCode_impl_lilec2(this.holder_1);
      }
      equals(other) {
        return ChannelResult__equals_impl_f471ri(this.holder_1, other);
      }
    }
    initMetadataForClass($, 'ChannelResult');
    ChannelResultClass = $;
  }
  return ChannelResultClass;
}
var ClosedReceiveChannelExceptionClass;
function ClosedReceiveChannelException() {
  if (ClosedReceiveChannelExceptionClass === VOID) {
    class $ extends NoSuchElementException() {
      constructor(message) {
        return new.target.new_kotlinx_coroutines_channels_ClosedReceiveChannelException_np7nzq_k$(message);
      }
      static new_kotlinx_coroutines_channels_ClosedReceiveChannelException_np7nzq_k$(message) {
        var $this = this.new_kotlin_NoSuchElementException_eborbh_k$(message);
        captureStack($this, $this.$throwableCtor_4);
        return $this;
      }
    }
    initMetadataForClass($, 'ClosedReceiveChannelException');
    ClosedReceiveChannelExceptionClass = $;
  }
  return ClosedReceiveChannelExceptionClass;
}
var ClosedSendChannelExceptionClass;
function ClosedSendChannelException() {
  if (ClosedSendChannelExceptionClass === VOID) {
    class $ extends IllegalStateException() {
      constructor(message) {
        return new.target.new_kotlinx_coroutines_channels_ClosedSendChannelException_f413rp_k$(message);
      }
      static new_kotlinx_coroutines_channels_ClosedSendChannelException_f413rp_k$(message) {
        var $this = this.new_kotlin_IllegalStateException_w47ei6_k$(message);
        captureStack($this, $this.$throwableCtor_4);
        return $this;
      }
    }
    initMetadataForClass($, 'ClosedSendChannelException');
    ClosedSendChannelExceptionClass = $;
  }
  return ClosedSendChannelExceptionClass;
}
function Channel(capacity, onBufferOverflow, onUndeliveredElement) {
  capacity = capacity === VOID ? 0 : capacity;
  onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
  onUndeliveredElement = onUndeliveredElement === VOID ? null : onUndeliveredElement;
  var tmp;
  switch (capacity) {
    case 0:
      tmp = onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance()) ? new (BufferedChannel())(0, onUndeliveredElement) : new (ConflatedBufferedChannel())(1, onBufferOverflow, onUndeliveredElement);
      break;
    case -1:
      // Inline function 'kotlin.require' call

      if (!onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance())) {
        var message = 'CONFLATED capacity cannot be used with non-default onBufferOverflow';
        throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
      }

      tmp = new (ConflatedBufferedChannel())(1, BufferOverflow_DROP_OLDEST_getInstance(), onUndeliveredElement);
      break;
    case 2147483647:
      tmp = new (BufferedChannel())(2147483647, onUndeliveredElement);
      break;
    case -2:
      tmp = onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance()) ? new (BufferedChannel())(Factory_getInstance().CHANNEL_DEFAULT_CAPACITY_1, onUndeliveredElement) : new (ConflatedBufferedChannel())(1, onBufferOverflow, onUndeliveredElement);
      break;
    default:
      tmp = onBufferOverflow === BufferOverflow_SUSPEND_getInstance() ? new (BufferedChannel())(capacity, onUndeliveredElement) : new (ConflatedBufferedChannel())(capacity, onBufferOverflow, onUndeliveredElement);
      break;
  }
  return tmp;
}
//region block: exports
export {
  ChannelResult__exceptionOrNull_impl_16ei30 as ChannelResult__exceptionOrNull_impl_16ei30skcgwlkg1n39,
  ChannelResult__getOrNull_impl_f5e07h as ChannelResult__getOrNull_impl_f5e07h3a081spbk3eji,
  _ChannelResult___get_holder__impl__pm9gzw as _ChannelResult___get_holder__impl__pm9gzw2lcu3ixrszjgj,
  _ChannelResult___get_isClosed__impl__mg7kuu as _ChannelResult___get_isClosed__impl__mg7kuul2jcxqhngcqm,
  _ChannelResult___get_isSuccess__impl__odq1z9 as _ChannelResult___get_isSuccess__impl__odq1z923tdiqn4dmkwh,
  Factory_getInstance as Factory_getInstance14vrned6uf29d,
  Companion_getInstance as Companion_getInstance2vekrswsg6p6,
  cancel$default as cancel$default3v09jht7i082i,
  close$default as close$default2suggcywjwe8g,
  Closed as Closed8t4xgopf7j5r,
  ChannelResult as ChannelResult2y4k69ac6y3du,
  Channel as Channel3r72atmcithql,
  ClosedReceiveChannelException as ClosedReceiveChannelException3ofg6gf5f5b38,
  ClosedSendChannelException as ClosedSendChannelException29m33prpq9jaw,
  ReceiveChannel as ReceiveChannel24wu5e2tj9lbp,
  SendChannel as SendChannel38sllbxw662ws,
};
//endregion

//# sourceMappingURL=Channel.mjs.map
